module.exports = {
	"AlsoToday": "Also Today",
	"Archive": "Archive",
	"ClickHereForMoreInfo": "Click here for more info",
	"ClientWebServiceNotResponding": "The authentication service is currently unavailable",
	"Confirm": "Confirm",
	"Digital": "Digital",
	"DigitalVersion": "Digital version",
	"Edition": "Edition",
	"Help": "Help",
	"HorsSeries": "Specials",
	"LoadingNewspaperPleaseWait": "Loading newspaper, please wait",
	"LogIn": "Log in",
	"LogInWith": "Log in with:",
	"MaximumDeviceNumberReached": "You have reached the number of allowed devices for this publication",
	"ModernBrowserRequired": "To read the digital newspaper you need Internet Explorer 9 or higher. We advise to update your browser or use another browser (Chrome, Firefox, ...).",
	"More": "More",
	"NewspaperCurrentlyUnavailable": "The newspaper cannot be opened at the moment. Please try again later.",
	"NoDigitalAccess": "You don't have digital access",
	"OK": "OK",
	"Paper": "Paper",
	"PaperVersion": "Paper version",
	"Password": "Password",
	"PleaseFillInAllFields": "Please fill in all fields",
	"Promospot": "Promospot",
	"ReadingPreference": "Reading preference",
	"Read": "Read",
	"ReadTheNewspaper": "Read the newspaper",
	"SelectEdition": "Select edition:",
	"SignIn": "Sign in",
	"SignOut": "Sign out",
	"SSOValidationFailed": "The automatic authentication has failed.",
	"Subscription": "Subscription",
	"TemporarilyUnavailable": "Temporarily unavailable",
	"TheUsernameAndOrPasswordIsIncorrect": "The Username and/or Password is incorrect",
	"UnknownError": "An unexpected error occurred",
	"UnknownUser": "The Username is incorrect",
	"Username": "Username",
	"ValidationFailed": "The authentication service is currently unavailable.",
	"YourSessionHasExpired": "Your session has expired",
	"downloadPDFerror": "You have reached the download limit for this edition",
	"Proceed": "Proceed",
	"ForgotPassword": "Forgot Password",
	"Cancel": "Cancel",
	"moment": "en-gb",
	"Extra": "Extra",
	"ChooseRegion": "Please select a region",
	"downloadingNewsPaper": "Your newspaper is downloading, please wait a moment. ",
	"CookieConfirmButton": "OK",
	"CookieLinkText": "More information",
	"CookieInformText": "This website uses cookies. By continuing to use this website you are giving consent to cookies being used. ",
	"home": "Home",
	"recently": "Recently",
	"supplements": "Supplements",
	"extras": "Extras",
	"inforAndExtras": "Info and extras",
	"regions": "Regions",
	"settings": "Settings",
	"region": "Region",
	"login": "Log in",
	"logout": "Log out",
	"help": "Help",
	"about": "About",
	"disclaimer": "Disclaimer",
	"account": "Account",
	"accountLoggedIn": "Logged in",
	"accountLoggedInInfo": "You are currently logged in.",
	"accountLoggedWithInfo": "You are currently logged in with",
	"accountLoggedOut": "Not logged in",
	"version": "Version",
	"platformversion": "Platform version",
	"uuid": "UUID",
	"editor": "Editor",
	"developer": "Developer",
	"downloading": "Downloading...",
	"journal": "Newspaper",
	"alsoRead": "Read also",
	"alsoWatch": "Watch also",
	"alsoSee": "See also",
	"authorising": "Authorising...",
	"notSupported": "This site can only be rendered in modern browsers. Please update your browser or download Chrome.",
	"printImage": "Image",
	"printText": "Text",
	"print": "Print",
	"jumpBack": "Back",
	"noInternetNoVideo": "You have to have internet connection to see this video",
	"download": "Download",
	"fullPdfDownload": "Full Publication",
	"pagePdfDownload": "Current Page",
	"pdfDownloadTooltip": "Download",
	"logoTooltip": "Back to the kiosk",
	"readerLogoTooltip": "Back to the kiosk",
	"landscapeToggle": "Landscape Reading",
	"singlePage": "Single page view",
	"singlePageShort": "Single page",
	"doublePage": "Double page view",
	"doublePageShort": "Double page",
	"passwordForgottenLoadingText": "Please wait while your page is loading",
	"landscapeToggleEExplanation": "When reading in landscape mode you can choose if you want to see 1 page at full page-width or a double page.",
	"PleaseFillInAValidEmail": "Please fill in a valid e-mail address.",
	"LeftPage": "Left page",
	"RightPage": "Right page",
	"Sorry": "Sorry!",
	"close": "Close",
	"printLeftPage": "Left page",
	"printRightPage": "Right page",
	"printSinglePage": "Current Page",
	"cropPrint": "Print",
	"cropPrintTitle": "Print",
	"cropPrintInstruction": "To print the full page click \"print\".<br>To print a portion of a page or a specific article, resize the blue border box by clicking and dragging on the corners and placing them around the portion of the page you’d like to print.",
	"openCMPSetting": "My privacy settings",
	"dataPolicy": "Data policy",
	"privacyPolicy": "Privacy Policy",
	"singlePageMode": "1 page view",
	"doublePageMode": "2 page view",
	"readingModeToggle": "Reading Mode",
	"E1": "Systems are unavailable, please try again later.",
	"E4": "Systems are unavailable, please try again later.",
	"E3": "The authentication service is currently unavailable.",
	"E5": "You don't have an active subscription.",
	"E6": "Invalid credentials. Check your email/password and try again.",
	"E7": "Invalid credentials. Check your email/password and try again.",
	"E8": "The newspaper cannot be opened at the moment. Please try again later.",
	"E9": "Systems are unavailable, please try again later.",
	"E11": "You have reached the maximum number of downloads with your subscription.",
	"E13": "Systems are unavailable, please try again later.",
	"E15": "Systems are unavailable, please try again later.",
	"E24": "Your subscription does not have enough rights to read the publication.",
	"E25": "You have reached the maximum number of concurrent sessions with your subscription.",
	"E26": "These login details can not be verified. Please try again or contact our customer service."
};


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/en_uk.json
// module id = 409
// module chunks = 0 1